import * as d3 from "d3";
import {
  ICircleRadiusItem,
  sizeCircleRadiusWeaksignal,
} from "../../../mocks/projectsMock";
import {ITypeRadar} from "../../../types";

const renderCircleRadii = (
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
  typeRadar: ITypeRadar,
  fiveCircleRadius: ICircleRadiusItem,
  fourthCircleRadius: ICircleRadiusItem,
  thirdCircleRadius: ICircleRadiusItem,
  secondCircleRadius: ICircleRadiusItem,
  firstCircleRadius: ICircleRadiusItem,
  isWeak_signal?: boolean,

  isNationalProjects?: boolean
) => {
  const circleRadii =
    typeRadar !== "fintech" || isWeak_signal
      ? isWeak_signal
        ? [
            fiveCircleRadius,
            sizeCircleRadiusWeaksignal.thirdCircleRadius,
            sizeCircleRadiusWeaksignal.secondCircleRadius,
            sizeCircleRadiusWeaksignal.firstCircleRadius,
          ]
        : [
            fiveCircleRadius,
            fourthCircleRadius,
            thirdCircleRadius,
            secondCircleRadius,
            firstCircleRadius,
          ]
      : [fiveCircleRadius, fourthCircleRadius, firstCircleRadius];

  circleRadii.forEach((itemRadius) => {
    mainGroup
      .append("circle")
      .attr("cx", 0)
      .attr("cy", 0)
      .attr("r", itemRadius.radius)
      .style("fill", "none")
      .style(
        "stroke",
        typeRadar === "moleculeTwo" && itemRadius === firstCircleRadius
          ? "white"
          : itemRadius.color
      )
      .style("stroke-width", itemRadius.thick ?? 0.5);
  });
};

export default renderCircleRadii;
